;(function(){
  try {
    var key = Object.getOwnPropertyNames(window).find(function(k){ return k && String(k).indexOf('untamed_protection_') === 0; });
    if (key && window[key] && window[key].disabled) return;
  } catch (_) {}

  function initHeader() {
    try {
      var toggles = document.querySelectorAll('.mobile-menu-toggle');
      var mobileClose = document.getElementById('mobile-menu-close');
      var mobileDrawer = document.getElementById('mobile-drawer');
      var overlay = document.getElementById('mobile-drawer-overlay');
      if (toggles.length && mobileDrawer && overlay) {
        toggles.forEach(function(btn){
          btn.addEventListener('click', function(){
            mobileDrawer.classList.add('is-active');
            overlay.classList.add('is-active');
            document.body.style.overflow = 'hidden';
            var fixedHeader = document.getElementById('site-header-fixed');
            if (fixedHeader) fixedHeader.style.display = 'none';
            btn.classList.add('active');
          });
        });
        if (mobileClose) {
          mobileClose.addEventListener('click', function(){
            mobileDrawer.classList.remove('is-active');
            overlay.classList.remove('is-active');
            document.body.style.overflow = '';
            var fixedHeader = document.getElementById('site-header-fixed');
            if (fixedHeader && window.scrollY > 0) fixedHeader.style.display = '';
            document.querySelectorAll('.mobile-menu-toggle').forEach(function(b){ b.classList.remove('active'); });
          });
        }
        overlay.addEventListener('click', function(){
          mobileDrawer.classList.remove('is-active');
          overlay.classList.remove('is-active');
          document.body.style.overflow = '';
          var fixedHeader = document.getElementById('site-header-fixed');
          if (fixedHeader && window.scrollY > 0) fixedHeader.style.display = '';
          document.querySelectorAll('.mobile-menu-toggle').forEach(function(b){ b.classList.remove('active'); });
        });
      }

      var mainHeader = document.getElementById('site-header-main');
      if (mainHeader) {
        var stickyType = mainHeader.getAttribute('sticky');
        function updateScrollState(){
          var y = window.scrollY;
          if (y > 10) { mainHeader.classList.add('header--scrolled'); }
          else { mainHeader.classList.remove('header--scrolled'); }
        }
        if (stickyType === 'always') {
          mainHeader.setAttribute('data-sticky-state', 'active');
          window.addEventListener('scroll', updateScrollState, { passive: true });
          updateScrollState();
        } else if (stickyType === 'scroll-up') {
          var lastY = window.scrollY;
          var ticking = false;
          function updateHeader(){
            var y = window.scrollY;
            if (y <= 50) {
              mainHeader.setAttribute('data-sticky-state', 'idle');
            } else if (y < lastY && y > 100) {
              mainHeader.setAttribute('data-sticky-state', 'active');
            } else if (y > lastY) {
              mainHeader.setAttribute('data-sticky-state', 'idle');
            }
            lastY = y;
            ticking = false;
          }
          window.addEventListener('scroll', function(){
            if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
          }, { passive: true });
          updateHeader();
        } else if (stickyType === 'never') {
          mainHeader.setAttribute('data-sticky-state', 'idle');
        }
      }

      document.querySelectorAll('.mobile-nav__submenu-toggle').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault();
          var parent = btn.closest('.mobile-nav__item--has-children');
          if (!parent) return;
          parent.classList.toggle('open');
          var expanded = parent.classList.contains('open');
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
      });

      // ==========================================
      // SIDE CART DRAWER LOGIC
      // The side cart content is rendered server-side in header.liquid
      // This JS handles open/close and cart item actions
      // ==========================================
      var cartIcon = document.querySelector('.header__cart-icon');
      var floatingCartBtn = document.getElementById('floating-cart-wrapper');
      var cartDrawer = document.getElementById('mobile-cart-drawer');
      var cartClose = document.getElementById('mobile-cart-drawer-close');
      var cartOverlay = document.getElementById('mobile-cart-drawer-overlay');

      function openSideCart(e) {
        if (cartDrawer && cartOverlay) {
          if (e) e.preventDefault();
          cartDrawer.classList.add('is-active');
          cartOverlay.classList.add('is-active');
          document.body.style.overflow = 'hidden';
          // Hide floating cart button when side cart is open
          if (floatingCartBtn) {
            floatingCartBtn.classList.add('fc-hidden-by-cart');
          }
          // Refresh cart content when opening to ensure latest items are shown
          setTimeout(function() {
            if (window.refreshSideCart) {
              window.refreshSideCart();
            }
          }, 100);
        }
      }

      // Make openSideCart globally available for cart add events
      window.openSideCart = function() {
        if (cartDrawer && cartOverlay) {
          cartDrawer.classList.add('is-active');
          cartOverlay.classList.add('is-active');
          document.body.style.overflow = 'hidden';
          // Hide floating cart button when side cart is open
          if (floatingCartBtn) {
            floatingCartBtn.classList.add('fc-hidden-by-cart');
          }
          // Refresh cart content when opening to ensure latest items are shown
          setTimeout(function() {
            if (window.refreshSideCart) {
              window.refreshSideCart();
            }
          }, 100);
        }
      };

      // Header cart icon opens side cart drawer
      if (cartIcon) {
        cartIcon.addEventListener('click', openSideCart);
      }

      // Floating cart button also opens side cart drawer
      if (floatingCartBtn) {
        floatingCartBtn.addEventListener('click', openSideCart);
      }

      function closeCart() {
        if (cartDrawer) cartDrawer.classList.remove('is-active');
        if (cartOverlay) cartOverlay.classList.remove('is-active');
        document.body.style.overflow = '';
        // Show floating cart button when side cart is closed
        if (floatingCartBtn) {
          floatingCartBtn.classList.remove('fc-hidden-by-cart');
        }
      }

      if (cartClose) cartClose.addEventListener('click', closeCart);
      if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

      // ==========================================
      // SIDE CART QUANTITY & REMOVE HANDLERS
      // ==========================================
      
      // Quantity buttons (using event delegation)
      document.addEventListener('click', function(e) {
        var qtyBtn = e.target.closest('.side-cart__qty-btn');
        if (qtyBtn) {
          e.preventDefault();
          var action = qtyBtn.dataset.action;
          var itemKey = qtyBtn.dataset.itemKey;
          var qtyDisplay = qtyBtn.closest('.side-cart__qty-selector').querySelector('.side-cart__qty-value');
          var currentQty = parseInt(qtyDisplay.textContent);
          var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
          
          // Show loading state
          var cartItem = qtyBtn.closest('.side-cart__item');
          if (cartItem) cartItem.style.opacity = '0.5';
          
          updateCartItem(itemKey, newQty);
        }
      });

      // Remove button
      document.addEventListener('click', function(e) {
        var removeBtn = e.target.closest('.side-cart__item-remove');
        if (removeBtn) {
          e.preventDefault();
          var itemKey = removeBtn.dataset.itemKey;
          
          // Show loading state
          var cartItem = removeBtn.closest('.side-cart__item');
          if (cartItem) cartItem.style.opacity = '0.5';
          
          updateCartItem(itemKey, 0);
        }
      });

      // Checkout button
      document.addEventListener('click', function(e) {
        var checkoutBtn = e.target.closest('[data-side-cart-checkout]');
        if (checkoutBtn && !checkoutBtn.disabled) {
          var discountCode = sessionStorage.getItem('discount_code');
          var checkoutUrl = '/checkout';
          if (discountCode) {
            checkoutUrl += '?discount=' + encodeURIComponent(discountCode);
          }
          window.location.href = checkoutUrl;
        }
      });

      // ==========================================
      // OFFERS PANEL TOGGLE
      // ==========================================
      var offersPanel = document.querySelector('[data-offers-panel]');
      
      // Open offers panel
      document.addEventListener('click', function(e) {
        var offersToggle = e.target.closest('[data-offers-toggle]');
        if (offersToggle && offersPanel) {
          e.preventDefault();
          offersPanel.classList.add('is-open');
        }
      });

      // Close offers panel
      document.addEventListener('click', function(e) {
        var offersClose = e.target.closest('[data-offers-close]');
        if (offersClose && offersPanel) {
          e.preventDefault();
          offersPanel.classList.remove('is-open');
        }
      });

      // Close offers panel when cart is closed
      var originalCloseCart = closeCart;
      closeCart = function() {
        if (offersPanel) offersPanel.classList.remove('is-open');
        originalCloseCart();
      };

      // ==========================================
      // SECURE BAND TOGGLE TEXT
      // ==========================================
      (function() {
        var texts = document.querySelectorAll('.side-cart__secure-toggle-text');
        if (texts.length < 2) return;
        var current = 0;
        setInterval(function() {
          texts[current].classList.remove('side-cart__secure-toggle-text--visible');
          current = (current + 1) % texts.length;
          texts[current].classList.add('side-cart__secure-toggle-text--visible');
        }, 3000);
      })();

      // ==========================================
      // REFRESH SIDE CART CONTENT
      // ==========================================
      var refreshSideCartTimeout = null;
      function refreshSideCart() {
        if (!cartDrawer) return;
        
        // Debounce rapid refresh calls
        if (refreshSideCartTimeout) {
          clearTimeout(refreshSideCartTimeout);
        }
        
        refreshSideCartTimeout = setTimeout(function() {
          // Fetch updated cart HTML from the header section
          // Use a cache-busting parameter to ensure we get fresh content
          var url = window.location.href.split('#')[0].split('?')[0];
          var cacheBuster = '?_refresh=' + Date.now();
          
          fetch(url + cacheBuster, {
            method: 'GET',
            cache: 'no-store',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Cache-Control': 'no-cache'
            }
          })
            .then(function(response) { 
              if (!response.ok) throw new Error('Network response was not ok');
              return response.text(); 
            })
            .then(function(html) {
              // Create a temporary DOM parser
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              
              // Find the new cart drawer content
              var newCartContent = doc.getElementById('mobile-cart-drawer-content');
              var newCartHeader = doc.querySelector('.side-cart__count[data-cart-count]');
              var newCartFooter = doc.querySelector('[data-cart-footer]');
              var newProgressBar = doc.querySelector('[data-progress-bar]');
              
              // Update cart items container
              var currentCartContent = document.getElementById('mobile-cart-drawer-content');
              if (newCartContent && currentCartContent) {
                currentCartContent.innerHTML = newCartContent.innerHTML;
              }
              
              // Update cart count in header
              if (newCartHeader) {
                var currentCartCount = document.querySelector('.side-cart__count[data-cart-count]');
                if (currentCartCount) {
                  currentCartCount.innerHTML = newCartHeader.innerHTML;
                }
              }
              
              // Update footer (subtotal, etc.)
              if (newCartFooter) {
                var currentCartFooter = document.querySelector('[data-cart-footer]');
                if (currentCartFooter) {
                  currentCartFooter.innerHTML = newCartFooter.innerHTML;
                }
              }
              
              // Update progress bar if it exists
              if (newProgressBar) {
                var currentProgressBar = document.querySelector('[data-progress-bar]');
                if (currentProgressBar) {
                  currentProgressBar.innerHTML = newProgressBar.innerHTML;
                }
              }
              
              // Reset opacity on all items
              resetOpacity();
            })
            .catch(function(err) {
              console.error('Error refreshing side cart:', err);
              resetOpacity();
            });
        }, 300); // Small delay to ensure server has processed the cart update
      }
      
      function resetOpacity() {
        document.querySelectorAll('.side-cart__item').forEach(function(item) {
          item.style.opacity = '1';
        });
      }

      // ==========================================
      // CART UPDATE FUNCTION
      // ==========================================
      function updateCartItem(id, quantity) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: quantity })
        })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          // Always refresh side cart content (will update when opened)
          refreshSideCart();
          // Also update header cart count
          if (window.refreshHeaderCart) {
            window.refreshHeaderCart();
          }
        })
        .catch(function(err) {
          console.error('Error updating cart:', err);
          resetOpacity();
        });
      }

      // ==========================================
      // LISTEN FOR CART UPDATE EVENTS
      // ==========================================
      // Listen for cart:updated and cart:refresh events
      document.addEventListener('cart:updated', function() {
        // Always refresh side cart content (it will be updated when opened)
        refreshSideCart();
        if (window.refreshHeaderCart) {
          window.refreshHeaderCart();
        }
      });
      
      document.addEventListener('cart:refresh', function() {
        // Always refresh side cart content (it will be updated when opened)
        refreshSideCart();
        if (window.refreshHeaderCart) {
          window.refreshHeaderCart();
        }
      });
      
      // Expose refreshSideCart globally so it can be called from other scripts
      // This will refresh the side cart whenever it's called, regardless of open state
      // The cart will be updated when it's next opened
      window.refreshSideCart = function() {
        refreshSideCart();
      };

      // ==========================================
      // UPDATE HEADER CART COUNT (global function)
      // ==========================================
      var _refreshHeaderCartTimer = null;
      window.refreshHeaderCart = function() {
        clearTimeout(_refreshHeaderCartTimer);
        _refreshHeaderCartTimer = setTimeout(function() {
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.querySelectorAll('.cart-count').forEach(function(span) {
                span.innerText = cart.item_count;
                span.style.display = cart.item_count > 0 ? 'flex' : 'none';
              });
              // Also update side cart count
              var sideCartCount = document.querySelector('[data-cart-count]');
              if (sideCartCount) {
                sideCartCount.textContent = '( ' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ' )';
              }
            })
            .catch(function(e) { console.error(e); });
        }, 300);
      };

    } catch (_) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader);
  } else {
    initHeader();
  }
})();
